import { createClient } from '@supabase/supabase-js'
import { authStorage } from '../../lib/authStorage'

// Mounted inside CostSpace (Create React App). CostSpace's own .env already
// defines REACT_APP_SUPABASE_URL/ANON_KEY for CostSpace's own Supabase
// project -- reusing those names here would silently point Estimation's
// client at the wrong (CostSpace) database. Estimation therefore uses its
// own, distinctly-named variables, pointing at Estimation's own Supabase
// project, defined in the same root .env file alongside CostSpace's.
const supabaseUrl = process.env.REACT_APP_ESTIMATION_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_ESTIMATION_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing REACT_APP_ESTIMATION_SUPABASE_URL or REACT_APP_ESTIMATION_SUPABASE_ANON_KEY. Check your .env file.'
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: { schema: 'estimation' },
  // Same storage policy as CostSpace's client (they share one session key) - see lib/authStorage.js
  auth: { storage: authStorage },
})
